import React from "react";
import { Link } from "react-router-dom";
import SimpleText from "./Components/SimpleText";
import BannerFullWidth from "./Components/BannerFullWidth";
import ProductList from "../Product/ProductList";
import CategoryPage from "../Pages/CategoryPage";
import SectionTitle from "./Components/SectionTitle";
import CategoryList from "./Components/CategoryList/CategoryList";

class Content extends React.Component {
    render() {
        if (this.props.content === null) {
            return <div className="page page-404">
                <h1 className="title">404 - The page could not be found</h1>
                <span className="text">Sorry, we can't find what you are looking for. Let's get you back on track...</span>
                <Link to="/shop" className="cta">Browse products</Link>
            </div>
        }

        var content = this.props.content.map((item, key) => {
            switch (item.blocktype) {
                case "bannerFullWidth":
                    return <BannerFullWidth key={key} key={key} content={item.bannerfullwidth} />
                
                case "productlist":
                    var categoryId = 0;
                    var count = null;
                    if (item.productlist.category) {
                        categoryId = item.productlist.category.databaseId;
                        count = item.productlist.category.count;
                    }
                    return <CategoryPage key={key}>
                        <ProductList perPage={12} categoryId={categoryId} productCount={count} />
                    </CategoryPage>

                case "sectionTitle":
                    return <SectionTitle key={key} title={item.sectiontitle.title} subtitle={item.sectiontitle.subtitle} />;

                case "simpleText":
                    return <SimpleText key={key} text={item.simpletext} />  
                
                case "categoryList":
                    return <CategoryList key={key} content={item.categorylist} />;

                default:
                    return null;
            }
        });
        
        return <div className="page-content">
            {content}
        </div>;
    }
}

export default Content;